import { KnownDevice, Device } from '@playq/octopus2-devices';
import { TraitDataType } from '@playq/octopus2-analytics';

import { formatDate } from '/helpers';
import { TraitValue } from '/component/Device/types';

export const checkDeviceStatus = (device: Device) => {
  return device instanceof KnownDevice;
};
export const checkDeviceConnection = (device: Device) => {
  return device.connection !== undefined;
};
export const checkDeviceName = (device: Device) => {
  return device instanceof KnownDevice ? device.name : device.alias.installationId;
};
export const cutUnderline = (str: string) => {
  if (typeof str !== 'string') {
    return '';
  }
  return str.replace(/_/gi, ' ');
};

export const generateValueType = (type: TraitDataType, value: TraitValue) => {
  if (type === TraitDataType.DateTime) {
    return formatDate(value.toString(), 'EEE DD t');
  }
  return value.toString();
};
